//////// GHG 3.8 EA
const threeEightSchema = {
  title: "3.8 Upstream Leased Assets",
  addAPI: "cat4_4AddEmissionActivityAPI",
  cat: "cat4_4",
  EATitle: "Emission Activity",
  fields: [
    //////// Activity Name
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Activity Name",
      resetOnChange: false,
      required: true,
    },
    //////// Asset Name
    {
      key: "assetName",
      level: 1,
      type: "input",
      label: "Asset Name",
      resetOnChange: false,
      required: true,
    },
  ],
};
export default threeEightSchema;
